/*
 * Copyright (C) 2025 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { generateValidationErrorId, InvalidParam, ValidationMessages } from '@common/tech-shared';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ValidationErrorComponent } from '../validation-error/validation-error.component';

@Component({
  selector: 'odc-editor-group',
  host: { class: 'block' },
  imports: [ValidationErrorComponent],
  templateUrl: './editor-group.component.html',
})
export class EditorGroupComponent implements OnInit, OnDestroy {
  @Input() formGroup: UntypedFormGroup;
  @Input() label: string;
  @Input() validationMessages: ValidationMessages;
  @Input() dataTestId: string;

  public readonly validationErrorId: string = generateValidationErrorId();

  public invalidParams: InvalidParam[] = [];

  _changesSubscription: Subscription;
  _statusSubscription: Subscription;

  ngOnInit(): void {
    this._changesSubscription = this.formGroup.valueChanges.subscribe(() => this._updateErrors());
    this._statusSubscription = this.formGroup.statusChanges.subscribe(() => this._updateErrors());
  }

  ngOnDestroy(): void {
    this._changesSubscription.unsubscribe();
    this._statusSubscription.unsubscribe();
  }

  _updateErrors(): void {
    this.invalidParams =
      this.formGroup.errors ? Object.keys(this.formGroup.errors).map((key) => <InvalidParam>this.formGroup.errors[key]) : [];
  }
}
